export const TRACKING_TAGS = ["input", "a", "button", "li"];

export const PERFORMANCE_STATUS_SESSION_KEY = "performanceStatusShown";

export const APP_VERSION_STORAGE_KEY = "rocketfuel_app_version";
